import toast from 'react-hot-toast';
import useApi from '../useApi';
import { confirmReq, confirmRes} from './index.type';

const useSendConfirmation = () => {
  const url = `/rtm/patient-enrollment/send-consent`
  const method =  'POST'; 
  const { loading: sendingConsent , makeApiCall } = useApi({ url, method });

  const sentConsent = async (formData: confirmReq) => {
    const { response, error } = await makeApiCall< confirmReq , confirmRes>(formData);;
    if (response?.status === 'success') {
 
      toast.success(`Sent Consent Message to ${formData.phone}` );
      return response;
    }

    if (error || !response?.status) {
      toast.error(error?.msg || 'Failed to send confirmation. Please try again.');
      return { status: 'fail' };
    }
  };

  return {
    sendingConsent,
    sentConsent,
  };
};

export default useSendConfirmation ;
